/**
 * Argument ConfValue. We have a ConfValue entity as well but that can't be used as a request model..
 */
export class ConfValueArgument {
  longId: number;
  value?: string | Array<ConfValueArgument>; // Multichoice value is an array of multichoices
  configurationId?: number;
}